import apiClient from './api';

export default {
  /**
   * 獲取所有分店資訊
   * @returns {Promise} 分店列表
   */
  getBranches() {
    return apiClient.get('/service/branchs');
  },
};
